<template>
  <div style="height: 100%;width:100%;">
    <v-card  flat>
      <v-card-text>
        <v-row v-if="useCountries && countries">
          <v-col cols="12" xs="12">
            <v-autocomplete
                v-model="country"
                :loading="loading"
                :items="countries"
                hide-no-data
                hide-details
                return-object
                class="mx-4"
                flat
                @change="select = null"
                item-text="n"
                label="Land"
                solo
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.n"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.s"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="country || !useCountries">
          <v-col cols="12" xs="12" v-if="!select">
            <v-text-field v-model="search" clearable outlined></v-text-field>
            <!--
            <v-autocomplete
                v-if="!select"
                v-model="select"
                :loading="loading"
                :items="items"
                :search-input.sync="search"
                hide-no-data
                hide-details
                return-object
                class="mx-4"
                flat
                color="primary"
                append-outer-icon="search"
                @change="getDetails"
                item-text="name"
                label="Hotelname"
                solo
            >
              <template v-slot:item="data">
                <v-list-item-content>
                  <v-list-item-title v-html="data.item.name"></v-list-item-title>
                  <v-list-item-subtitle v-html="data.item.gid + ' (' + data.item.country + ', ' + data.item.region + ')'"></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            -->
          </v-col>
          <v-col cols="12" xs="12" sm="6" align="right" v-if="false">
            <v-btn class="mx-2" v-if="select" @click="select = null; hotel = null;">
              <v-icon class="mr-2">hotel</v-icon>
              {{ truncatedString(select.name) }}
              <v-icon color="red">close</v-icon>
            </v-btn>
            <v-btn v-if="useCountries && country" @click="country = undefined;select = null; hotel = null;">
              <v-icon class="mr-2">map</v-icon>
              {{ country.n }}
              <v-icon color="red">close</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0" class="flex">
            <span class="title"> {{hotel.name}}</span>
            <v-icon color="red" @click="close" style="float: right">close</v-icon>
          </v-col>
          <v-col cols="12" xs="1" v-if="select && hotel && showType === 0">
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0">
            <span class="chapter"><strong>Veranstalter:</strong> {{hotel.provider}}</span>
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0">
            <span class="chapter"><strong>GIATA-ID:</strong> {{select.gid}}</span>
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0">
            <span class="chapter"><strong>Bilder (Vorschau): </strong></span>
          </v-col>

          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0">
            <v-row>
              <div class="gallery">
                <img v-for="pic in highResImages" :key="pic" :src="pic.url" style="max-width: 202px; max-height: 160px"/>
              </div>
                <!--
                <div
                    :style="stageStyle + 'background-position: center;background-repeat: none;background-size: contain;background-image: url(\'' + pic.url +'\')'">
                </div>
                -->
            </v-row>
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0 && (hotel.map || hotel.details)">
            <span class="chapter"><strong>Standortkarte: </strong></span>
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0">
            <div v-if="hotel.map"
                 :style="stageStyle + 'background-position: left;background-repeat: none;background-size: contain;background-image: url(\'' + hotel.map +'\')'">
            </div>
            <GoogleMapLoader
                v-else-if="hotel.details"
                :style="stageStyle + ';display:grid;'"
                :mapConfig="mapConfig"
                :apiKey="mapKey"
            />
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0 && hotel.text">
            <span class="chapter"><strong>Beschreibung: </strong></span>
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0 && hotel.text">
            <div class="chapter_desc">
              <span class="chapter" v-html="hotel.text"></span>
            </div>

          </v-col>

          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0 && hotel.clima">
            <span class="chapter"><strong>Klima: </strong></span>
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0 && hotel.clima">
            <div
                 :style="stageStyle + 'background-position: left;background-repeat: none;background-size: contain;background-image: url(\'' + hotel.clima +'\')'">
            </div>
          </v-col>
          <v-col cols="12" xs="12" v-if="select && hotel && showType === 0 && hotel.detail">
            <div :style="stageStyle" v-if="hotel.detail.urls">
              <div v-if="hotel.imageList && hotel.imageList.length > 0">
                <img :src="hotel.imageList[0].url" v-if="hotel.imageList.length > 0" class="mr-1">
                <img :src="hotel.imageList[1].url" v-if="hotel.imageList.length > 1" class="mr-1">
                <!--
                <img :src="hotel.imageList[2].url" v-if="hotel.imageList.length > 2" class="mr-1">
                <img :src="hotel.imageList[3].url" v-if="hotel.imageList.length > 3">
                -->
              </div>
              <div v-for="(addr, i) in hotel.detail.addresses" :key="i">
                <span class="title">
                  Standort
                </span> <br>
                <span class="subtitle-1">
                  {{addr.street}} {{addr.streetNum}}<br>
                  {{addr.zip}} {{addr.cityName}}</span>
              </div>
              <div v-for="(url, i) in hotel.detail.urls" :key="i">
                <span class="title">
                  Web:
                </span> <br>
                <span class="subtitle-1"><a :href="url.url" target="_blank">{{ url.url }}</a></span>
              </div>
              <div v-for="(section, i) in hotel.detail.texts['de'].sections" :key="i">
                <span class="title pt-2">
                  {{ section.title }}
                </span> <br>
                <span class="description">
                  {{ section.para }}
                </span>
              </div>
            </div>
          </v-col>
          <v-col cols="12" xs="12" v-if="showType === 3 && items && items.length > 0 " class="mx-0 py-0">
            <v-data-table
                :headers="headers"
                :items="items"
                fixed-header
                :items-per-page="-1"
                @click:row="doSelectRow"
                hide-default-footer
                :height="tableHeight"
            >
              <template v-slot:item.name="{ item }">
                <v-row>
                  <v-col cols="12" xs="6">
                    <!--<img v-if="item.thumb" :src="item.thumb" width="128" style="float: left;" class="mr-4"/>-->
                    <ImageItem
                        class="article-item__image mr-4"
                        v-if="item.thumb"
                        :source="item.thumb"
                        style="float: left;"
                    />
                    <div v-else style="width: 320px; height: 240px;float:left; background-color: lightgray;" class="mr-4"></div>
                    <span class="title">{{item.name}}</span><br>
                    <span class="subtitle-1">{{item.country}} / {{item.region}}</span>&nbsp;<span class="text">{{item.provider}}</span>
                  </v-col>
                </v-row>

              </template>
            </v-data-table>
          </v-col>
        </v-row>


      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import Vue from "vue";
import debounce from 'lodash/debounce';
import ImageItem from "./../../ImageItem.vue";
import GoogleMapLoader from "@/components/module/GoogleMapLoader.vue";

export default {
  name: 'OfficeClientGiata',
  components: {GoogleMapLoader, ImageItem},
  data() {
    return {
      gmap: {
        mapConfig: Object,
        apiKey: String,
      },
      urlLogo: './../../assets/Logo.png',
      countries: undefined,
      country: {
        n: 'Italien',
        s: 'IT'
      },
      useCountries: false,
      loading: false,
      mapConfig: {
        center: { lat: -34.397, lng: 150.644 },
        zoom: 8,
      },
      mapKey: 'AIzaSyAetXJoHCE7Ealp9F5OECNvOF6hItEPabk',
      items: [],
      stageStyle: 'height:240px;overflow-y: auto;overflow-x: hidden;',
      stageHeight: 420,
      cmodel: 0,
      search: null,
      showType: 0,
      hotel: undefined,
      details: undefined,
      select: null,
      maxLength: 24,
      tableHeight: 100,
      Map: null,
      myMap: null,
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Anbieter', align: 'left', value: 'provider'},
        {text: 'GiataID', align: 'right', value: 'gid'},
        /*
      {text: 'Land', value: 'country'},
      {text: 'Region', value: 'region'}

         */
      ],
      debouncedQuery: null,
    }
  },
  watch: {
    search(val) {
      this.debouncedQuery(val);
    },
  },
  computed: {
    highResImages() {
      const images = this.hotel.imageList || []

      // Gruppiere nach typ + seq
      const buckets = new Map()

      images.forEach(image => {
        const meta = image.meta || {}
        const key = meta.typ + '_' + meta.seq

        if (!buckets.has(key)) {
          buckets.set(key, [])
        }
        buckets.get(key).push(image)
      })

      const result = []

      buckets.forEach(imageGroup => {
        const hasIds = imageGroup.some(img => img.meta && img.meta.id)

        // Filtere nach vorhandenem id
        const filtered = hasIds
            ? imageGroup.filter(img => img.meta && img.meta.id)
            : imageGroup

        // Wähle bestes Bild (nach width * height)
        const best = filtered.reduce((a, b) => {
          const aMeta = a.meta || {}
          const bMeta = b.meta || {}

          const resA = parseInt(aMeta.width || 0, 10) * parseInt(aMeta.height || 0, 10)
          const resB = parseInt(bMeta.width || 0, 10) * parseInt(bMeta.height || 0, 10)

          return resB > resA ? b : a
        })

        result.push(best)
      })

      return result
    }
  },
  methods: {
    truncatedString(value) {
      return value.length > this.maxLength
          ? `${value.slice(0, this.maxLength)}...`
          : value;
    },
    getDetails() {
      this.querySelectionsDetails(this.select.gid, this.select.provider)
    },
    doSelectRow(item, dontRoute) {
      if (dontRoute) {
        this.select = item
        this.getDetails()
        return;
      }
      this.items = []
      this.$router.push('/ga/index/' + item.gid + '/' + item.provider)
      this.select = item
      this.getDetails()
    },
    close() {
      this.select = null
      this.hotel = null
      this.showType = 0
      this.$router.push('/ga/index')
    },
    querySelectionsDetails(gid,provider) {
      const cmp = this
      cmp.hotel = null
      let regData = {
        gid: gid,
      }
      if (provider) {
        regData.vc = provider
      }
      Vue.prototype.$apiOfficeClient.getHotelDetail(regData, function (result) {
        if (result) {
          cmp.hotel = result.hotels[0]
          if (Object.keys(result.detail).length > 0) {
            cmp.hotel.detail = result.detail
            if (result.detail.geoCodes && result.detail.geoCodes.length > 0) {
              cmp.mapConfig.center.lat = result.detail.geoCodes[0].latitude
              cmp.mapConfig.center.lng = result.detail.geoCodes[0].longitude
            }

          }

          cmp.$nextTick(function () {
            cmp.cmodel = 0
            if (cmp.hotel.detail) {
              // cmp.show(2)
            } else {
              cmp.cmodel = 1
              cmp.show(0)
              cmp.cmodel = 0
            }
          })
        }
        cmp.loading = false
      }, this.onFailedCode)
    },
    querySelections(v) {
      const cmp = this
      // if (v.length < 2) return
      cmp.loading = true
      Vue.prototype.$apiOfficeClient.queryHotelByName({
        name: v,
        country: null, //cmp.country.n,
      }, function (result) {
        cmp.loading = false
        cmp.items = result
        cmp.show(3)
      }, this.onFailedCode)
    },
    onFailedCode: function () {
      this.loading = false
    },
    openGiata: function () {
      const gid = this.hotel.gid
      window.open('https://myhotel.giatamedia.com/hotel-directory/' + gid + "?lang=de", '_new')
    },
    /**
     *
     * @param type 0 = Bilder, 1 = map
     */
    show: function (type) {
      this.showType = type
      if (type === 1) {
        this.showMap()
      }
    },
    initMap: async function () {
      //
    },
    showMap: function () {
      //
    },
    updateStageStyle: function () {
      this.stageHeight = window.innerHeight - 200
      this.stageStyle = 'height:' + this.stageHeight + 'px;overflow-y: auto;overflow-x: hidden;'
      this.tableHeight = this.stageHeight
    }
  },
  mounted() {
    const cmp = this
    cmp.initMap()

    if (this.$route.params.giataId && this.$route.params.provider) {
      this.doSelectRow({
        gid: this.$route.params.giataId,
        provider: this.$route.params.provider
      },true)
    }

    this.debouncedQuery = debounce(this.querySelections, 300);

    this.updateStageStyle()
    if (cmp.useCountries) {
      Vue.prototype.$apiOfficeClient.getCountries({}, function (result) {
        cmp.countries = result
      }, this.onFailedCode)
    }
  }
}
</script>

<style scoped>
.gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-left: 14px;
  margin: 1em 0;
}
.chapter {
  color: #000000;
  font: 20px sans-serif;

}
.chapter_desc {
  background: #f9f9f9;
  padding: 1em;
  border: 1px solid #ddd;
  white-space: pre-wrap;
  line-height: 1.5;
  font-size: 1em;
}
.title,
h2 {
  color: #004080;
  font-size: 30px;
  font-weight: bold;
  unicode-bidi: isolate;
}
</style>
